import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Card, CardHeader, Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-bs5';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { H4 } from '../../../AbstractElements';
import { EarnTableHeader } from '../../../Constant';
import ManageEarn from '../../../api/ManageEarn';

const earnStatusBadge = (status) => {
    switch (status) {
        case 'PENDING':          return '<span class="badge bg-warning text-dark">EN ATTENTE</span>';
        case 'VALIDATED':        return '<span class="badge bg-info text-dark">VALIDÉ</span>';
        case 'WAITING_RECLAME':  return '<span class="badge bg-secondary">EN ATTENTE RÉCLAM.</span>';
        case 'RECLAMED':         return '<span class="badge bg-success">RÉCLAMÉ</span>';
        default:                 return `<span class="badge bg-dark">${status}</span>`;
    }
};

const EarnsTab = () => {
    const tableRef = useRef(null);
    const [clientEarns, setClientEarns] = useState([]);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);
    const [clientDetail, setClientDetail] = useState(null);

    const loadEarns = () => {
        ManageEarn.loadAllEarns()
            .then((response) => {
                const meta = response.data.response;
                if (meta.status_code === 200) {
                    const data = response.data.data !== undefined ? response.data.data : meta.data;
                    const grouped = Object.entries(data || {}).map(([clientId, earns]) => ({
                        clientId,
                        clientName: earns[0]?.client?.complete_name || '',
                        phoneNumber: earns[0]?.client?.phone_number || '',
                        count: earns.length,
                        total: earns.reduce((sum, earn) => sum + Number(earn.earn_amount || 0), 0),
                    }));
                    setClientEarns(grouped);
                } else {
                    toast.error(meta.message || "Erreur lors du chargement des gains.");
                }
            })
            .catch(() => {
                toast.error("Erreur lors du chargement des données. Réessayer plus tard.");
            });
    };

    const showClientDetail = (clientId, clientName) => {
        setIsDetailModalOpen(true);
        setIsLoadingDetail(true);
        setClientDetail(null);
        ManageEarn.getClientEarns(clientId)
            .then((response) => {
                const meta = response.data.response;
                if (meta.status_code === 200) {
                    const data = response.data.data !== undefined ? response.data.data : meta.data;
                    setClientDetail({ clientName, ...data });
                } else {
                    toast.error(meta.message || "Erreur lors du chargement du détail.");
                }
            })
            .catch(() => {
                toast.error("Erreur lors du chargement du détail. Réessayer plus tard.");
            })
            .finally(() => setIsLoadingDetail(false));
    };

    useEffect(() => {
        const $table = $(tableRef.current);

        if (!$.fn.DataTable.isDataTable(tableRef.current)) {
            $table.DataTable({
                order: [[3, 'desc']],
                language: {
                    processing:     "Traitement en cours...",
                    search:         "Rechercher&nbsp;:",
                    lengthMenu:     "Afficher _MENU_ éléments",
                    info:           "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
                    infoEmpty:      "Affichage de l'élément 0 à 0 sur 0 élément",
                    infoFiltered:   "(filtré de _MAX_ éléments au total)",
                    infoPostFix:    "",
                    loadingRecords: "Chargement en cours...",
                    zeroRecords:    "Aucun élément à afficher",
                    emptyTable:     "Aucune donnée disponible dans le tableau",
                    paginate: {
                        first:      "Premier",
                        previous:   "Précédent",
                        next:       "Suivant",
                        last:       "Dernier"
                    },
                    aria: {
                        sortAscending:  ": activer pour trier la colonne par ordre croissant",
                        sortDescending: ": activer pour trier la colonne par ordre décroissant"
                    }
                },
                data: [],
                columns: EarnTableHeader.map((header) => ({ title: header })),
            });
        }

        loadEarns();

        return () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $table.DataTable().destroy();
            }
        };
    }, []);

    useEffect(() => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            const table = $(tableRef.current).DataTable();
            table.clear();

            clientEarns.forEach((client) => {
                table.row.add([
                    client.clientName,
                    client.phoneNumber,
                    client.count,
                    client.total,
                    `<button class='btn btn-sm btn-primary detail-btn' data-id='${client.clientId}' data-name='${client.clientName}'>
                        <i class='fa fa-eye'></i> Voir détail
                     </button>`
                ]);
            });
            table.draw();

            $(tableRef.current).off('click', '.detail-btn').on('click', '.detail-btn', function () {
                const clientId = $(this).data('id');
                const clientName = $(this).data('name');
                showClientDetail(clientId, clientName);
            });
        }
    }, [clientEarns]);

    return (
        <Fragment>
            <ToastContainer />
            <Card>
                <CardHeader>
                    <H4 attrH4={{ className: 'card-title mb-0' }}>
                        Gains par utilisateur
                    </H4>
                </CardHeader>
                <div className='table-responsive edit-table'>
                    <table
                        ref={tableRef}
                        className='display table table-striped table-vcenter text-nowrap'
                        style={{ width: '100%' }}
                    >
                        <thead>
                        <tr>
                            {EarnTableHeader.map((header, i) => (
                                <th key={i}>{header}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody></tbody>
                    </table>
                </div>
            </Card>

            <Modal isOpen={isDetailModalOpen} toggle={() => setIsDetailModalOpen(false)} centered size="lg">
                <ModalHeader toggle={() => setIsDetailModalOpen(false)}>
                    Gains de {clientDetail?.clientName}
                </ModalHeader>
                <ModalBody>
                    {isLoadingDetail ? (
                        <div className="text-center py-4">
                            <span className="spinner-border spinner-border-sm"></span>
                        </div>
                    ) : clientDetail ? (
                        <Fragment>
                            <p className="mb-3"><strong>Total des gains :</strong> {clientDetail.total_earn}</p>
                            <Table responsive size="sm" bordered>
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Montant</th>
                                    <th>Statut</th>
                                    <th>Transaction ID</th>
                                    <th>Créé le</th>
                                </tr>
                                </thead>
                                <tbody>
                                {(clientDetail.earns || []).map((earn) => (
                                    <tr key={earn.id}>
                                        <td>{earn.id}</td>
                                        <td>{earn.earn_amount}</td>
                                        <td dangerouslySetInnerHTML={{ __html: earnStatusBadge(earn.earn_status) }} />
                                        <td>{earn.transaction_id}</td>
                                        <td>{earn.created_at}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </Fragment>
                    ) : null}
                </ModalBody>
            </Modal>
        </Fragment>
    );
};

export default EarnsTab;
